<template>
	<div class="cardDetail">
		<ul>
			<template v-for="item in cardDetail.sublst">
				<li>
					<p class="l">{{item.product.name}}</p>
					<p class="r"><span>{{item.sub.billCount}}</span> 张</p>
				</li>
				<li class="code">
					<span v-for="item1 in item.codeList">{{item1.codeNo}}</span>
				</li>
			</template>

		</ul>
		<p class="price" style="text-align: right;">实体卡费用 共计 <span> {{cardDetail.cardCount}} </span>张：<span class="colo">￥{{(cardDetail.bill.realAmount - cardDetail.bill.expressAmount)/100}} 元</span></p>
		<div class="price">
			<p class="l">地址:</p>
			<p class="r" v-if="cardDetail.addr"><i class="el-icon-location" style="color: #00ABFA;"></i> {{cardDetail.addr.address}}</p>
			<p class="r" v-else><i class="el-icon-location" style="color: #00ABFA;"></i>自提</p>
		</div>
		<div>
			<p class="r price">运费：<span class="colo">￥{{cardDetail.bill.expressAmount/100}}</span></p>
		</div>
		<div class="price">
			<p class="l w1">备注：</p>
			<p class="l w2">{{cardDetail.bill.remark}}</p>
		</div>
		<div>
			<p class="r price">费用统计：<span class="colo">￥{{cardDetail.bill.realAmount/100}} 元</span></p>
		</div>
		<div>
			<p class="r price">付款方式：<span>银行转账</span></p>
		</div>
		<div>
			<p class="r price">物流状态：<span class="coloR">{{status[cardDetail.bill.expressState]}}</span></p>
		</div>

		<router-link style='color: inherit;' to="/commodity/buyList"><el-button type="primary" class='btn'>关闭</el-button></router-link>
	</div>
</template>

<script>
	import { entityDetailList } from '@/axios/api.js'
	import common from '@/assets/common.js'
	export default {
		data() {
			return {
				cardDetail:{},
				status:['未发','已发','签收'],
			}
		},
		methods: {
			setTime(str) {
				return common.time(str)
			},
			getData(){
				var data={
					billId:this.$route.query.id,
				}
				entityDetailList(data)
				.then(res => {
					this.data=res.data.obj;
					console.log(this.cardDetail.sublst)
					this.cardDetail.sublst.forEach( item => {
						var prodectId=item.product.id
						item.codeList=[]
						this.data.forEach( item1 => {
							if(item1.product.id == prodectId){
								item.codeList.push(item1)
								this.$forceUpdate();
							}
						})
					})
				})
				.catch(err => {
					console.log(err)
				})
			}
		},
		created() {
			if(!this.$route.params.data) return this.$router.go(-1)
			this.cardDetail=this.$route.params.data;
			console.log(this.cardDetail)
			this.getData()
		}
	}
</script>
<style>
	.has-gutter th {
		background-color: #f5f7fb;
	}
</style>
<style scoped="scoped">
	h3 {
		color: #333;
		font-weight: bold;
		margin-bottom: 20px;
		margin-top: 20px;
	}

	ul,
	li {
		list-style: none;
	}

	ul {
		overflow: hidden;
	}

	ul li {
		overflow: hidden;
		line-height: 40px;
	}

	.l {
		float: left;
	}

	.r {
		float: right;
	}

	p {
		line-height: 40px;
		color: #333;
		font-size: 16px;
	}

	.price {
		font-size: 14px;
		line-height: 40px;
	}

	.colo {
		color: #ff7200;
	}

	.coloR {
		color: #df1717;
	}

	div {
		overflow: hidden;
	}

	.w1 {
		width: 50px;
	}

	.w2 {
		width: 850px;
	}

	.blue {
		margin: 0 auto;
		width: 100px;
		height: 40px;
		display: block;
		background: #00ABFA;
		color: #fff;
		text-align: center;
		line-height: 40px;
		margin-top: 20px;
	}

	.cardDetail {
		margin-top: 20px;
		height: calc(100vh - 160px);
		overflow: auto;
		padding: 0 20px;
		max-width: 900px;
		margin: 0 auto;
	}
	.btn{display: block;margin: 0 auto;margin-top: 30px;}
	.code{overflow: hidden;}
	.code span{padding-right: 20px;float: left;}
</style>



// WEBPACK FOOTER //
// src/views/card/cardOrderDetail.vue